/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Aktion beim Klick auf einen Block der statischen Seiten.
 * NONE          = nichts (Vorgabe)
 * POPUP         = zeigt actionContent als Meldung
 * UNSUBSCRIBE   = traegt die eingegebene Adresse aus dem Verteiler aus
 *                 (oeffentlicher Abmelde-Weg) und zeigt danach
 *                 actionContent
 * MINIGOLF_BAHN = zeigt die Beschreibung der AKTUELLEN Bahn: Grafik,
 *                 Norm, Abschlag als Zifferblatt, Ballempfehlungen und
 *                 Spielweise (Betreiber 22.09.2026, mit Prototyp).
 * 
 *                 SIE ERSCHEINT NUR, WENN DIE ROLLEN ZUGEORDNET SIND.
 *                 Der Baustein liest nichts aus festen Feldnamen,
 *                 sondern ueber die Zuordnung im Mapping
 *                 (`minigolfBahnNummer`, `…Grafik`, `…AbschlagStunde`
 *                 und die uebrigen). Ohne Zuordnung gibt es nichts zu
 *                 zeigen, und die Aktion wird gar nicht erst angeboten.
 * @export
 */
export const DatabasePageBlockActionType = {
    None: 'NONE',
    Popup: 'POPUP',
    Unsubscribe: 'UNSUBSCRIBE',
    MinigolfBahn: 'MINIGOLF_BAHN'
} as const;
export type DatabasePageBlockActionType = typeof DatabasePageBlockActionType[keyof typeof DatabasePageBlockActionType];


export function DatabasePageBlockActionTypeFromJSON(json: any): DatabasePageBlockActionType {
    return DatabasePageBlockActionTypeFromJSONTyped(json, false);
}

export function DatabasePageBlockActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePageBlockActionType {
    return json as DatabasePageBlockActionType;
}

export function DatabasePageBlockActionTypeToJSON(value?: DatabasePageBlockActionType | null): any {
    return value as any;
}

